<template>
  <router-link class="g-lsti" :to="{ name: 'game', params: { id: game.id } }">
    <div class="g-lsti__table">
      <div class="g-lsti__row">
        <span class="g-lsti__key">Creator:</span>
        <span class="g-lsti__value">{{ game.creator.displayName }}</span>
      </div>

      <div class="g-lsti__row">
        <span class="g-lsti__key">Players:</span>
        <span class="g-lsti__value">{{ game.players.length }}</span>
      </div>

      <div class="g-lsti__row">
        <span class="g-lsti__key">Status:</span>
        <span class="g-lsti__value">{{ game.status | capitalize }}</span>
      </div>

      <div class="g-lsti__row">
        <span class="g-lsti__key">Is Locked:</span>
        <span
          class="g-lsti__value g-lsti__value--success"
          :class="{ 'g-lsti__value--danger': game.isLocked }"
        >
          {{ game.isLocked ? 'Locked' : 'Unlocked' }}
        </span>
      </div>
    </div>
  </router-link>
</template>

<script>
  export default {
    props: {
      game: {
        type: Object,
        required: true,
      },
    },
    filters: {
      capitalize(value) {
        if (!value) return '';

        value = value.toString();

        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      },
    },
  };
</script>

<style scoped lang="scss">
  .g-lsti {
    width: 156px;
    height: 156px;
    background: url('../../assets/img/game/table.png') no-repeat center;
    background-size: contain;
    display: inline-block;
    color: #ffffff;
    position: relative;
    font-size: 11px;
    border-radius: 50%;

    &__table {
      width: 100%;
      //
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &__row {
      text-align: left;
      padding: 0 4px;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__key,
    &__value {
      width: 50%;
      vertical-align: middle;
      display: inline-block;
    }

    &__key {
      text-align: right;
      font-weight: normal;
      padding-right: 4px;
    }

    &__value {
      text-align: left;
      font-family: monospace;
      padding-left: 4px;
      //
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      &--success {
        color: $green;
      }

      &--danger {
        color: $red;
      }
    }
  }
</style>
